import { useState, useEffect } from "react"
import CalcLoan from "./CalcLoan"

const Calculator = () => {
  return <CalcLoan />
}

export default Calculator
